// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sxrx","toggleWrap":"styles_toggleWrap__1vX4B","content":"styles_content__1Chzm","selectAreaCode":"styles_selectAreaCode__QDtY2"};